import React from 'react';
import { TrendingUp, DollarSign, Smartphone, Heart } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-223">
      {/* Background blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-rose-100 rounded-full blur-3xl opacity-60 -translate-y-1/2 translate-x-1/2" data-id="element-224"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-soft rounded-full blur-3xl opacity-40 translate-y-1/3 -translate-x-1/4" data-id="element-225"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-227">
          <span className="bg-brand-primary/10 text-brand-primary px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-6 inline-block" data-id="element-228">
            La Revolución Femenina
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-medium text-brand-dark mt-2 mb-6 leading-tight" data-id="element-229">
            El secreto que las empresas <br data-id="element-230" />
            <span className="text-brand-primary italic" data-id="element-231">
              no quieren que sepas
            </span>
          </h2>
          <p className="text-lg text-brand-muted/90 leading-relaxed" data-id="element-232">
            Hay miles de empresas perdiendo fortunas porque no tienen quien
            conteste sus llamadas con empatía y tacto. No buscan hombres
            agresivos con trajes caros. <br data-id="element-233" />
            <span className="font-bold text-brand-dark block mt-4 text-xl" data-id="element-234">
              Buscan mujeres como tú. Que saben escuchar. Que saben conectar.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-235">
          {/* Feature 1 */}
          <div className="group bg-brand-light p-8 rounded-[2rem] border border-rose-100 hover:border-brand-primary/30 hover:shadow-xl hover:shadow-rose-200/50 transition-all duration-300" data-id="element-236">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform" data-id="element-237">
              <Heart className="w-7 h-7 text-brand-primary" data-id="element-238" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-brand-dark mb-3" data-id="element-239">
              El Poder Femenino
            </h3>
            <p className="text-brand-muted" data-id="element-240">
              Las mujeres somos naturalmente mejores para conectar
              emocionalmente. Esa es tu mayor ventaja competitiva en este
              mercado.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="group bg-brand-light p-8 rounded-[2rem] border border-rose-100 hover:border-brand-primary/30 hover:shadow-xl hover:shadow-rose-200/50 transition-all duration-300" data-id="element-241">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform" data-id="element-242">
              <DollarSign className="w-7 h-7 text-brand-primary" data-id="element-243" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-brand-dark mb-3" data-id="element-244">
              Ingresos Reales
            </h3>
            <p className="text-brand-muted" data-id="element-245">
              Olvídate de los $15/hora. Aquí hablamos de comisiones de $200,
              $500 o hasta $1,000 por una sola llamada exitosa.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="group bg-brand-light p-8 rounded-[2rem] border border-rose-100 hover:border-brand-primary/30 hover:shadow-xl hover:shadow-rose-200/50 transition-all duration-300" data-id="element-246">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform" data-id="element-247">
              <Smartphone className="w-7 h-7 text-brand-primary" data-id="element-248" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-brand-dark mb-3" data-id="element-249">
              Libertad Total
            </h3>
            <p className="text-brand-muted" data-id="element-250">
              Sin inventario. Sin envíos. Sin jefes respirándote en la nuca. Tu
              oficina está donde esté tu celular.
            </p>
          </div>
        </div>
      </div>
    </section>;
}